{
  "name": "@uppy/google-photos-picker",
  "description": "The Google Photos Picker plugin for Uppy lets users import files from their Google Photos account",
  "version": "0.4.2",
  "license": "MIT",
  "main": "lib/index.js",
  "type": "module",
  "scripts": {
    "build": "tsc --build tsconfig.build.json",
    "typecheck": "tsc --build"
  },
  "keywords": [
    "file uploader",
    "google photos",
    "google picker",
    "cloud storage",
    "uppy",
    "uppy-plugin"
  ],
  "homepage": "https://uppy.io",
  "bugs": {
    "url": "https://github.com/transloadit/uppy/issues"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/transloadit/uppy.git"
  },
  "files": [
    "src",
    "lib",
    "dist",
    "CHANGELOG.md"
  ],
  "dependencies": {
    "@uppy/companion-client": "workspace:^",
    "@uppy/provider-views": "workspace:^",
    "@uppy/utils": "workspace:^",
    "preact": "^10.5.13"
  },
  "peerDependencies": {
    "@uppy/core": "workspace:^"
  },
  "devDependencies": {
    "@uppy/core": "workspace:^",
    "typescript": "^5.8.3"
  }
}
